import { render, staticRenderFns } from "./ozoneAlarmDetail.vue?vue&type=template&id=3d7dd636&scoped=true"
import script from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
export * from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./ozoneAlarmDetail.vue?vue&type=style&index=0&id=3d7dd636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7dd636",
  null
  
)

export default component.exports